import React, { Fragment, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { AlertCircle } from 'react-feather';
import Breadcrumb from '../common/breadcrumb';
import { Home } from 'react-feather';
import { userRequest } from '../../auth/requestMethods';
import { Link } from 'react-router-dom';

const Default = () => {
  const [warnings, setWarnings] = React.useState({ publicHoliday: 0, schoolCalendar: 0 });

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();

  // If we are in the last 3 months choose next year
  const year = currentMonth >= 9 ? currentYear + 1 : currentYear;

  useEffect(() => {
    document.title = 'PSFA | Dashboard';
  }, []);

  React.useEffect(() => {
    const page = 1;
    const perPage = 100;

    bulkAxios([
      `/public-holidays?per_page=${perPage}&page=${page}&year=${year}`,
      `/school-calendars?per_page=${100}&page=${1}&is_active=1&terms=0`,
    ])
      .then((all) => {
        let publicHoliday = all[0].publicHolidays.length;
        let schoolCalendar = all[1].schoolCalendars.length;

        setWarnings({ publicHoliday, schoolCalendar });
      })
      .catch((res) => console.log(res));
  }, [year]);

  function bulkAxios(urls = null) {
    if (!urls) return urls;

    let promises = urls.map((req) =>
      userRequest()
        .get(req)
        .then(({ data }) => {
          return data;
        })
        .catch((error) => {
          console.log(error);
          return null;
        })
    );

    return Promise.all(promises);
  }

  return (
    <Fragment>
      <Breadcrumb icon={<Home />} link="/dashboard" parent="Dashboard" title="PSFA Feeding Module" />
      {!warnings.publicHoliday && (
        <Alert className="m-15 d-flex gap-3" color="warning dark">
          <AlertCircle />
          <p>No public holidays have been created for {year} yet. </p>
          <Link to="/public-holidays/manage"> Create Public Holiday</Link>
        </Alert>
      )}
      {!!warnings.schoolCalendar && (
        <Alert className="m-15 d-flex gap-3" color="warning dark">
          <AlertCircle />
          <p>
            {warnings.schoolCalendar} School Calendars don&apos;t have School Terms for {year} yet.
            <Link to="/school-calendars/manage"> Create School Term</Link>
          </p>
        </Alert>
      )}
    </Fragment>
  );
};

export default Default;
